module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"compare_period":"比較期間"}}')
  delete Component.options._Ctor
}
